import { api_GET } from "services/api_service.js";
import { getSessionCookie } from "services/session.js";
import { showMessage } from "./message";

export default function ValidaAcessoFuncionalidadeAcao(funcionalidadeAcao, callback) {
    let session = getSessionCookie();
    if (session && session.tipoAcesso == "Protocolo") {
        callback(false);
        return;
    }

    if (session.login == "csj") {
        callback(true);
        return;
    }

    api_GET('usuario/ValidaAcessoFuncionalidadeAcao/' + session.usuario_Id + "/" + funcionalidadeAcao)
        .then(result => { callback(result.data) })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
};